import { Component } from '@theme/component';

/**
 * Shares a product with the device's native share sheet.
 * Falls back to copying the product link when sharing isn't available.
 * @extends {Component}
 */
class ProductShareButton extends Component {
  /** @type {number | undefined} */
  #hideMessageTimeout;

  async share() {
    const url = this.getAttribute('share-url');

    if (!url) return;

    if (navigator.share) {
      try {
        await navigator.share({ title: this.getAttribute('share-title') ?? undefined, url });
        return;
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      this.#showCopiedMessage();
    } catch {
      // Clipboard access can be blocked by the browser; nothing else to do.
    }
  }

  #showCopiedMessage() {
    const { copiedMessage } = this.refs;

    if (!(copiedMessage instanceof HTMLElement)) return;

    copiedMessage.hidden = false;
    clearTimeout(this.#hideMessageTimeout);
    this.#hideMessageTimeout = setTimeout(() => {
      copiedMessage.hidden = true;
    }, 2000);
  }
}

if (!customElements.get('product-share-button')) {
  customElements.define('product-share-button', ProductShareButton);
}
